import React, { useEffect } from 'react';
import useJobs from '../../shared/jobs/useJobs';
import useSnapshotChecker from '../../shared/snapshotChecker/useSnapshotChecker';
import Snackbar from './Snackbar';
import useNavigation from './hooks/useNavigation';

export default function RootComponents({ navigateToState }) {
  useJobs();
  useNavigation(navigateToState);
  // Use the snapshot checker and get the restart function
  const { restartPublishCheck } = useSnapshotChecker();

  // Explicitly call restartPublishCheck when the component mounts
  useEffect(() => {
    // This will trigger the initial check and will continue polling until emptyQ is true
    restartPublishCheck();
  }, [restartPublishCheck]); // Only run once when the component mounts and if restartPublishCheck changes

  // We could potentially make this available through context if needed elsewhere
  return (
    <>
      <Snackbar />
    </>
  );
}
